import Image from 'next/image';
import yahoo from '@/app/images/logos/yahoo.png';
import advertise from '@/app/images/advertise.png';
import amazon from '@/app/images/amazon.png';
import aol from '@/app/images/aol.png';
import equifax from '@/app/images/equifox.png';
import credit from '@/app/images/credit.png';
import clsx from 'clsx';

export default function TrustedByClients() {
    return (
        <div className="row clients">
            <ul className={clsx(
                "opacity-60",
                "flex",
                "flex-wrap",
                "justify-center",
                "px-[30px]",
                "gap-[10px] sm:gap-[20px] md:gap-[30px]",
            )}>
                <li><Image width={121} height={32} src={yahoo} alt="yahoo" /></li>
                <li><Image width={159} height={32} src={advertise} alt="advertise" /></li>
                <li><Image width={162} height={32} src={amazon} alt="amazon" /></li>
                <li><Image width={66} height={32} src={aol} alt="aol" /></li>
                <li><Image width={161} height={32} src={equifax} alt="equifax" /></li>
                <li><Image width={191} height={32} src={credit} alt="credit" /></li>
            </ul>
        </div>
    );
};